// Whether App.vue sets up the 60-minute inactivity auto-logout.
//
// LIVE: always yes. TEST only: no - an idle TEST session stays signed in (with the
// TEST-only silent token renewal, see src/silentTokenRenewal.js).
//
// VUE_APP_SILENT_TOKEN_RENEWAL is set in .env.test only and vue.config.js defines it as ''
// otherwise, so the condition below is a compile-time constant: in a LIVE build the
// require is dropped and src/testNoIdleLogout.js never reaches the bundle.
// scripts/check-bundle-endpoint.js proves it (its marker must be absent from LIVE and
// present in TEST, and LIVE must still carry the 60-minute inactivityDuration).
const testNoIdleLogout = process.env.VUE_APP_SILENT_TOKEN_RENEWAL === 'on'
  ? require('./testNoIdleLogout').default
  : null

export function shouldSetUpIdleLogout () {
  if (testNoIdleLogout) {
    testNoIdleLogout()
    return false
  }
  return true
}
